import React from "react";
import { useUser } from "../utils/userContext";
import { getDevUserOverride, setDevUserOverride } from "../utils/devImpersonation";
import styles from "./ImpersonationBanner.module.css";

export default function ImpersonationBanner() {
  const { activeTenant } = useUser();
  const target = getDevUserOverride();
  if (!target) return null;
  const name = `${target.firstName || ""} ${target.lastName || ""}`.trim() ||
    target.businessName || String(target.userId);
  const tenant = activeTenant?.tenantName || activeTenant?.name || target.tenantId || "No tenant";
  return (
    <div className={styles["impersonation-banner"]} role="status">
      <span>Impersonating {name} ({tenant})</span>
      <button type="button" onClick={() => setDevUserOverride(null)}>Stop</button>
    </div>
  );
}
